function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.129 35.862c-2.98-1.994-7.575-7.103-4-14.992 7.248 7.179 6.96 10.373 4 14.992M36.969 48.096c2.627 2.861 8.766 7.177 16.167 3.247-8.78-6.849-12.003-6.408-16.167-3.247"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.418 44.197a9.526 9.526 0 01-9.526 9.526 9.526 9.526 0 01-9.527-9.526 9.526 9.526 0 019.527-9.526 9.526 9.526 0 019.526 9.526zM18.36 45.188a8.125 8.125 0 113.419-8.344M30.41 35a7.74 7.74 0 117.603 9.197"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(39.239)",
  cx: 52.032,
  cy: 0.477,
  rx: 2.648,
  ry: 2.138
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 27.16,
  cy: 41.294,
  rx: 4.168,
  ry: 3.572
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "scale(-1 1) rotate(39.238)",
  cx: 13.715,
  cy: 34.845,
  rx: 2.648,
  ry: 2.138
})), /*#__PURE__*/React.createElement("path", {
  d: "M18.592 47.513c-3.687-1.224-11.149-2.011-15.707 5.02 11.002 1.718 13.604-.233 15.707-5.02"
}));

var SvgBlueberry = function SvgBlueberry(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlueberry, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Blueberry.87226b9d.svg";
export { ForwardRef as ReactComponent };